import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import { useStyles } from './helpers';
import BlockReplenishment from '../../components/block-replenishment';
import BlockWithdrawal from '../../components/block-withdrawal';
import BlockBonus from '../../components/block-bonus';
import BlockRezym from '../../components/block-rezym';
import BlockDetalization from '../../components/block-detalization';
// import { ReactComponent as Cross } from '../../../../../@casino/img/cross.svg';
import { ReactComponent as TableIcon } from '../../../../../@casino/img/table.svg';
import { ReactComponent as User } from '../../../../../@casino/img/user.svg';
import { ReactComponent as Password } from '../../../../../@casino/img/password.svg';
import Dialog from '@material-ui/core/Dialog';
import clsx from 'clsx';
import { setUpdatePassword } from '../../store/thunk/setUpdatePassword';
import { setPostBlockUser } from '../../store/thunk/setPostBlockUser';
import Title from '../../../../../@casino/ui/title';
import BlockJackpot from '../../components/block-jackpot';
import BlockFreespin from '../../components/block-fs';
import { setPostLiftingIssue } from '../../store/thunk/setPostLifting';
import BlockHistorySignIn from '../../components/block-history-signin';
import FsModal from '../../components/fsModal';
import { setPostSignUser } from '../../store/thunk/setPostSignUser';
import { setGetJackpotList } from '../../../../mobile/gamer/store/thunk/setGetJackpotList';
import { setPostJackpotIssue } from '../../../../mobile/gamer/store/thunk/setPostJackpotIssue';
import { Allow as AllowMap } from '../../../../settings/allow';
import BlockBet from '../../components/block-bet';
import { setPutUpdatePaymentByUserId } from '../../store/thunk/setPutUpdatePaymentByUserId';
import { setGetTags } from '../../store/thunk/setGetTags';
import {ReactComponent as Cross} from './helpers/cross.svg';
import { setPutTags } from '../../store/thunk/setPutTags';
import ModalAddTag from '../../components/ModalAddTag';
import ModalConfirm from '../../../../../@casino/components/Modals/Confirm';
import { setUpdateClientId } from '../../store/thunk/setUpdateClientId';

const View = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const id = router.match.params.id;
    const profile = useSelector(state => state.users.view);
    const classes = useStyles();
    const [openModal, setOpenModal] = React.useState(false);
    const [randomPassword, setRandomPassword] = React.useState('');
    const [lifting, setLifting] = React.useState(false);
    const [fs, setFs] = React.useState(false);
    const [amountLifting, setAmountLifting] = React.useState(0);
    const [wager, setWager] = React.useState(0);
    const [maxBonus, setMaxBonus] = React.useState(0);
    const [jackpot, setJackpot] = React.useState(false);
    const [itemJackpot, setItemJackpot] = React.useState('');
    const [isNewTag, setIsNewTag] = React.useState(false);

    const view = useSelector(state => state.auth.admin);
    const list = useSelector(state => state.users.list);

    const jackpot_group = useSelector(state => state.usersMobile.jackpot);
    const tags = useSelector((state) => state.users.tags);

    React.useEffect(() => {
        dispatch(setGetUserById(id));
        dispatch(setGetTags({user_id: id}))
    }, [id]);

    const handleChangeMode = () => {
        setIsNewTag((value) => !value);
    }

    const getJackpot = (item) => {
        switch (item) {
            case 'gold': return 'Золотой';
            case 'silver': return 'Серебрянный';
            case 'bronze': return 'Бронзовый';
            case 'platinum': return 'Платиновый';
            default: return null;
        }
    }
    const [isChangeUserStatus, setIsChangeUserStatus] = React.useState(false);
    const [isChangePaymentStatus, setIsChangePaymentStatus] = React.useState(false);
    const [isChangeClientId, setIsChangeClientId] = React.useState(false);

    const handleChangeUserStatus = () => {
        setIsChangeUserStatus(value => !value)
    }

    const handleChangePaymentStatus = () => {
        setIsChangePaymentStatus(value => !value)
    }

    const handleChangeClientId = () => {
        setIsChangeClientId(value => !value)
    }

    const handleUpdateUserStatus = () => {
        dispatch(setPostBlockUser({
            login: profile.login,
            block: !profile.block,
            id
        }, handleChangeUserStatus))   
    }

    const handleUpdatePaymentStatus = () => {
        dispatch(setPutUpdatePaymentByUserId({
            user_id: profile.id,
            user_login: profile.login
        }, handleChangePaymentStatus));    
    }

    const handleUpdateClientId = () => {
        dispatch(setUpdateClientId({
            user_id: profile.id
        }, handleChangeClientId))
    }

    const Allow = AllowMap();

    if (!profile) {
        return <div>loading</div>
    }



    return (
        <div className={classes.rootOne}>
            <div className={classes.wrapTitle}>
                <Title label="Отчет по игрокам" />
            </div>
            <dii>
                <div className={classes.wrapBlock}>
                    <div style={{display: 'flex', alignItems: 'center', columnGap: 12 }}>
                        <span style={{
                             color: 'hsla(0,0%,100%,.5)', 
                             fontFamily: 'PT-sans, sans-serif', 
                             fontSize: 12, 
                             paddingTop: 2
                        }}>Теги: </span>
                        <div style={{display: 'flex', columnGap: 8, alignItems: 'center'}}>
                            {
                                tags.map((item) => (
                                    <div style={{background: '#fff2f0', border: '1px solid #ffccc7', padding: '0px 0px 0px 12px', borderRadius: '8px', display: 'flex', alignItems: 'center', columnGap: 10}}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.88)', fontSize: 12, fontFamily: 'PT-sans, sans-serif', lineHeight: 0, }}>{item.tag}</span>
                                        <div 
                                            style={{borderLeft: '1px solid #ACACAC', paddingLeft: 5, paddingRight: 5, cursor: 'pointer'}}
                                            onClick={() => {
                                                dispatch(setPutTags({
                                                    tag_id: item.id,
                                                    user_id: id
                                                }))
                                            }}
                                        >
                                            <Cross className={classes.cross} />
                                        </div>   
                                        
                                    </div>
                                ))
                            }
                            {
                                !tags?.length && (
                                    <div style={{background: '#fff2f0', border: '1px solid #ffccc7', padding: '0px 12px 2px', borderRadius: '8px'}}>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.88)', fontSize: 12, fontFamily: 'PT-sans, sans-serif', lineHeight: 0, }}>Теги отсутствуют</span>
                                    </div>
                                )
                            }
                            <div style={{background: '#fff2f0', border: '1px solid #ffccc7', padding: '0px 12px 2px', borderRadius: '8px', cursor: 'pointer'}} onClick={handleChangeMode}>
                                <span style={{ color: 'rgba(0, 0, 0, 0.88)', fontSize: 12, fontFamily: 'PT-sans, sans-serif', lineHeight: 0, }}>Новый тег</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.wrapBlock}>
                    {
                        view?.allow?.includes(Allow.UserBlock.allow) &&
                        <div className={classes.mr16} onClick={handleChangeUserStatus} style={{cursor: 'pointer'}}>
                            <div className={classes.wrapcross}>
                                <Cross className={classes.cross} />
                            </div>
                            <span className={classes.block}>
                                {profile.block ? 'Разблокировать игрока' : 'Заблокировать игрока'}
                            </span>
                        </div>
                    }
                    <div className={classes.mr16}>
                        <div className={classes.wrapTable}
                            onClick={() => router.history.push(`/gamer/list/report-game/${id}`)}
                        >
                            <TableIcon className={classes.table} />
                        </div>
                        <span className={classes.reportGamer}
                            onClick={() => router.history.push(`/gamer/list/report-game/${id}`)}
                        >Отчет по играм</span>
                    </div>
                    <div className={classes.mr16}>
                        <div className={classes.wrapUser}
                            onClick={() => router.history.push(`/gamer/list/report-event/${id}`)}
                        >
                            <User className={classes.user} />
                        </div>
                        <span className={classes.reportEvent}
                            onClick={() => router.history.push(`/gamer/list/report-event/${id}`)}
                        >Отчет о событиях</span>
                    </div>
                    {
                        view?.allow?.includes(Allow.ChangePassword.allow) &&
                        <div className={classes.mr16}>
                            <div
                                className={classes.wrapPassword}
                                onClick={() => setOpenModal(true)}
                            >
                                <Password className={classes.password} />
                            </div>
                            <span className={classes.passwordLabel}
                                onClick={() => setOpenModal(true)}
                            >Сбросить пароль</span>
                        </div>
                    }
                    <div className={classes.mr16}>
                        <span
                            style={{ padding: '10px 15px', background: '#FF3156', color: '#000', borderRadius: 4, cursor: 'pointer' }}
                            onClick={() => setLifting(true)}
                        >Подъемные</span>
                    </div>
                    <div className={classes.mr16}>
                        <span
                            style={{ padding: '10px 15px', background: '#FF3156', color: '#000', borderRadius: 4, cursor: 'pointer' }}
                            onClick={() => setFs(true)}
                        >Выдать FS</span>
                    </div>

                    {
                        view?.allow?.includes(Allow.JackpotIssue.allow) &&
                        <div className={classes.mr16}
                            onClick={() => {
                                dispatch(setGetJackpotList({
                                    group: profile.groups_cashiers
                                }))
                                setJackpot(true)
                            }} >
                            <span className={classes.btnJp}
                            >Выдать Jackpot</span>
                        </div>
                    }

                    {
                        (view?.role === 'root' || view?.role === 'support') &&
                        <div className={classes.mr16}>
                            <span
                                style={{ padding: '10px 15px', background: '#FF3156', color: '#000', borderRadius: 4, cursor: 'pointer' }}
                                onClick={() => {
                                    dispatch(setPostSignUser({
                                        id: profile.id
                                    }))
                                }}
                            >Войти под игроком</span>
                        </div>
                    }
                    {
                        view?.role === 'root' &&
                        <div className={classes.mr16}>
                            <span
                                style={{ padding: '10px 15px', background: '#FF3156', color: '#000', borderRadius: 4, cursor: 'pointer' }}
                                onClick={() => {
                                    handleChangePaymentStatus()
                                }}
                            >{profile.is_disabled_payment_system ? 'Включить Payment' : 'Отключить Payment'}</span>
                        </div>
                    }
                    {
                        view?.role === 'root' &&
                        <div className={classes.mr16}>
                            <span
                                style={{ padding: '10px 15px', background: '#FF3156', color: '#000', borderRadius: 4, cursor: 'pointer' }}
                                onClick={handleChangeClientId}
                            >Изменить ClientId</span>
                        </div>
                    }
                </div>
            </dii>
            <div className={classes.root} >
                <div className={classes.wrapInformation}>
                    <BlockDetalization profile={profile} />
                    {/* <BlockDocuments id={id} /> */}
                </div>
                <div className={classes.wrapBlockTable} >
                    <BlockHistorySignIn id={id} />
                    <BlockRezym id={id} />
                    <BlockBet id={id} />
                    <BlockReplenishment login={profile.login} />
                    <BlockWithdrawal login={profile.login} />
                    <BlockBonus id={id} />
                    {profile && profile.login && <BlockJackpot profile={profile} />}
                    <BlockFreespin id={id} />
                </div>
            </div>
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div className={classes.wrapDialog}>
                    <div>
                        <span className={classes.resetPassword}>
                            Сброс пароля
                        </span>
                    </div>
                    {
                        !!!randomPassword &&
                        <>
                            <div className={classes.mt12}>
                                <span className={classes.generate}>Сгенерировать новый пароль?</span>
                            </div>
                            <div className={classes.mt16}>
                                <span
                                    className={clsx(classes.save, classes.bgSave)}
                                    onClick={() => {
                                        const rand = Math.floor(Math.random() * 999999);
                                        setRandomPassword(rand);
                                        dispatch(setUpdatePassword({
                                            login: profile.login,
                                            password: String(rand)
                                        }))
                                    }}
                                >
                                    Сгенерировать
                                </span>
                                <span
                                    className={clsx(classes.save, classes.bgCansel)}
                                    onClick={() => setOpenModal(false)}
                                >
                                    Отмена
                                </span>
                            </div>
                        </>
                    }
                    {
                        !!randomPassword &&
                        <>
                            <div className={classes.mt16}>
                                <span className={classes.newPassword}>Новый пароль: {randomPassword}</span>
                            </div>
                            <div className={classes.mt16}>
                                <span
                                    className={clsx(classes.save, classes.bgOffBonus)}
                                    onClick={() => setOpenModal(false)}
                                >
                                    ОК
                                </span>
                            </div>
                        </>
                    }

                </div>
            </Dialog>
            <Dialog onClose={() => {
                setLifting(false);
                setAmountLifting(0)
                setWager(7);
            }} open={lifting}>
                <div style={{ padding: 20 }}>
                    <label htmlFor="amountLifting">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Сумма подъемных</span>
                        <input
                            type="text"
                            style={{width: 'calc(100% - 20px)', padding: 10, outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                            placeholder="Введите сумму"
                            id="amountLifting"
                            value={amountLifting}
                            onChange={(v) => {
                                if (!isNaN(+v.target.value)) {
                                    setAmountLifting(+v.target.value);
                                }
                            }}
                        />
                    </label>
                    <label htmlFor="wager">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Wager</span>
                        <div style={{position: 'relative'}}>
                            <span style={{color: '#acacac', position: 'absolute', top: 23, left: 10}}>x</span>
                            <input
                                type="text"
                                style={{width: 'calc(100% - 20px)', padding: '10px 10px 10px 17px', outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                                placeholder="Введите сумму"
                                id="wager"
                                value={wager}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setWager(+v.target.value);
                                    }
                                }}
                            />
                        </div>
                    </label>
                    <label htmlFor="max_bonus">
                        <span className={classes.label} style={{ color: '#2F2F2F', fontSize: 16, textAlign: 'center' }}>Максимальная сумма бонуса</span>
                        <div style={{position: 'relative'}}>
                            <span style={{color: '#acacac', position: 'absolute', top: 23, left: 10}}>x</span>
                            <input
                                type="text"
                                style={{width: 'calc(100% - 20px)', padding: '10px 10px 10px 17px', outline: 'none', border: '1px solid #eee', marginTop: 12, marginBottom: 12, borderRadius: 4 }}
                                placeholder="Введите сумму"
                                id="max_bonus"
                                value={maxBonus}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setMaxBonus(+v.target.value);
                                    }
                                }}
                            />
                        </div>
                    </label>
                    
                    <label htmlFor="currency">
                        <span>Валюта</span>
                        <input
                            type="text"
                            style={{ width: 'calc(100% - 20px)', padding: 10, outline: 'none', border: '1px solid #eee', borderRadius: 4 }}
                            value={profile.currency}
                            disabled={true}
                        />
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span
                            style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                if (amountLifting && wager && maxBonus) {
                                    const object = {
                                        id: profile.id,
                                        amount: +amountLifting,
                                        wager: +wager,
                                        max_bonus: +maxBonus
                                    }
                                    dispatch(setPostLiftingIssue(object));
                                    setLifting(false);
                                    setAmountLifting(0);
                                    setWager(0)
                                }
                            }}
                        >Пополнить</span>
                        <span style={{ marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
                            onClick={() => {
                                setLifting(false)
                                setAmountLifting(0)
                            }}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => {
                setJackpot(false);
                setItemJackpot();
            }} open={jackpot}>
                <div style={{ width: 300, padding: 20 }}>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                        <select 
                        size={1}
                            onChange={(v) => {
                                const parseObj = JSON.parse(v.target.value)
                                const obj = {
                                    bet: list.data.length ? list.data[0].amount_bet : '',
                                    game_uuid: list.data.length ? list.data[0].game_uuid : '',
                                    group: profile.groups_cashiers,
                                    id: +parseObj.id,
                                    jackpot: parseObj.jackpot,
                                    type: "give out",
                                    user: profile.login,
                                    amount: +parseObj.amount
                                }
                                setItemJackpot(obj);
                            }}
                            style={{padding: 10, border: '1px solid #eee', borderRadius: 4, width: '100%'}}
                            >
                            <option selected style={{ display: 'none' }}>Выбрать джекпоты</option>
                            {
                                jackpot_group?.map((item) => (
                                    <option style={{padding: '10px 0'}} value={`{"id": "${item.id}", "jackpot": "${item.jackpot}", "amount": "${item.primary_amount}"}`}>{getJackpot(item.jackpot)} {item.label}({item.primary_amount}) </option>
                                ))
                            }
                        </select>
                    </div>
                    {
                        itemJackpot &&
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '12px 0' }}>
                                <span style={{fontSize: 18}}>Сумма: {new Intl.NumberFormat('ru-RU').format(itemJackpot.amount ? itemJackpot.amount.toFixed(2) : itemJackpot.amount)} </span>
                        </div>
                    }
                    <div style={{ marginTop: 12 }}>
                        <span style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700
                        }}
                            onClick={() => {
                                dispatch(setPostJackpotIssue(itemJackpot))
                                setItemJackpot();
                                setJackpot(false)
                            }}
                        >Выдать</span>
                    </div>
                </div>
            </Dialog>

            <FsModal setFs={setFs} fs={fs} id={id} profile={profile} />
            {
                isNewTag && (
                    <ModalAddTag handleChangeMode={handleChangeMode} user_id={id} />
                )
            }
            {
                isChangeUserStatus && (
                    <ModalConfirm
                        handleCancel={handleChangeUserStatus}
                        handleSuccess={handleUpdateUserStatus}
                        description="Вы уверены, что хотите сменить статус пользователя?"
                    />
                )
            }
            {
                isChangePaymentStatus && (
                    <ModalConfirm
                        handleCancel={handleChangePaymentStatus}
                        handleSuccess={handleUpdatePaymentStatus}
                        description="Вы уверены, что хотите сменить статус платежных систем?"
                    />
                )
            }
            {
                isChangeClientId && (
                    <ModalConfirm
                        handleCancel={handleChangeClientId}
                        handleSuccess={handleUpdateClientId}
                        description="Вы уверены, что хотите сменить CLIENT_ID? Убедитесь, что у пользователя нет активной сессии в игре!"
                    />
                )
            }
        </div>
    )
}

export default View;